import React, { Component } from 'react';

// import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
// import DateFnsUtils from '@date-io/date-fns';
import { Box, Grid, FormControl, FormHelperText, TextField } from '@mui/material';
import 'date-fns';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


class DateTimePicker extends Component {

    render(){
        const { label, value, minDate, maxDate, error, required } = this.props;
        return (
            <Box p={1}>
                <FormControl variant="outlined" error={!!error} style={{ width: "100%" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker
                                // disableFuture
                                hideTabs
                                ampm={false}
                                invalidDateMessage="Date Invalide"
                                variant="outlined"
                                // minDate={minDate}
                                // maxDate={maxDate}
                                id="date-picker-dialog"
                                format="dd/MM/yyyy HH:mm"
                                label={`${label}${required && " *"}`} // undefined if not required
                                // label={`${label}`}
                                value={value}
                                inputVariant="outlined"
                                onChange={this.props.onChange || this.props.handleChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                InputLabelProps={{ shrink: true }}
                                autoOk={true}
                                // helperText={error}
                            />
                        </MuiPickersUtilsProvider> */}
                        <DesktopDateTimePicker
                            invalidDateMessage="Date Invalide"
                            variant="outlined"
                            minDate={minDate}
                            maxDate={maxDate}
                            id="date-time-picker-dialog"
                            label={`${label}${required ? " *": ""}`} // undefined if not required
                            // label={`${label}`}
                            value={value}
                            inputVariant="outlined"
                            onChange={this.props.onChange || this.props.handleChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            InputLabelProps={{ shrink: true }}
                            autoOk={true}
                            // helperText={error}
                            format="dd/MM/yyyy HH:mm"
                            renderInput={(params) => <TextField variant="outlined" {...params} />}
                            ampm={false}
                        />
                        <FormHelperText>{error}</FormHelperText>

                    </LocalizationProvider>
                </FormControl>
            </Box>
        )
    }  
}

export default DateTimePicker;

